/**
 * The plan label in the top bar (mission 9 WP14 T086; FR-015; B.1; squad U13, U26; contracts/ui-api.md
 * "The shell"): `planLabelMonthly` or `planLabelAnnual`, and `planLabelEnding` with the date access
 * ends when the plan is set to cancel. Nothing while pending, with no plan, or with no `billing` member
 * (a mission 3 body). It observes `['credits']`, the chip's read, so it adds no request.
 */
import { useQuery } from '@tanstack/react-query'

import { date } from '@/lib/format'
import { PROVISIONAL_COPY, copyText } from '@/lib/provisional-copy'
import { creditsQuery } from '@/lib/queries'

export function PlanLabel() {
  const { data } = useQuery(creditsQuery())
  const billing = data?.billing
  if (billing === undefined || billing.state === 'pending_subscription' || billing.plan === null) return null
  const name = copyText(billing.plan === 'annual' ? 'planLabelAnnual' : 'planLabelMonthly')
  const ends = billing.cancel_at_period_end && billing.period_end !== null ? billing.period_end : null
  return (
    <p data-plan-label="" className="text-caption text-navy-600">
      {name}
      {ends !== null ? (
        <>
          {' · '}
          <span>{PROVISIONAL_COPY.planLabelEnding.render({ date: date(ends) })}</span>
        </>
      ) : null}
    </p>
  )
}
